export const numberFormat = (value: number) =>
  new Intl.NumberFormat().format(value);

numberFormat(50000); //output as ₹ 50,000.00
numberFormat(10000);
